import { FC, memo, useCallback, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { LastLayerContext, Layer } from '@cargomart/ui'
import { useOnMount } from 'hooks'

import { MODAL_IDS, useModal } from '../ModalProvider'
import { checkIsLastLayer } from './helpers'
import { ModalItemProps } from './types'

const ModalItem: FC<ModalItemProps> = (props) => {
  const { children, id, isOpen = false } = props
  const { modals, openModal } = useModal()

  const modalPortalContainer = useMemo(() => document.getElementById('MODAL_PORTAL_CONTAINER'), [])

  const handleCheckIsLastLayer = useCallback((modalId: string) => checkIsLastLayer(modalId, modals), [modals])

  const isOpenCurrent = useMemo(() => modals.some((modal) => modal.id === id), [id, modals])

  useOnMount(() => {
    if (isOpen) {
      openModal(id as `${MODAL_IDS}`)
    }
  })

  return (
    <>
      {isOpenCurrent && (
        <Layer>
          <LastLayerContext.Provider value={handleCheckIsLastLayer(id)}>
            {modalPortalContainer && createPortal(children, modalPortalContainer)}
          </LastLayerContext.Provider>
        </Layer>
      )}
    </>
  )
}

export default memo(ModalItem)
